import axios from 'axios';

import {loadCompanysDataWithUserId} from '../company/actions.js'
import AppUtils from "../../../utils/AppUtils";
import {CLEAR_A_TOWJOB_ERROR_MESSAGE, clearTowErrorMsgInStore} from "../towjob/actions";


export const LOAD_USER_DATA = 'user/LOAD_USER_DATA';
export const DELETE_A_USER = 'user/DELETE_A_USER';
export const SAVE_A_USER = 'user/SAVE_A_USER';
export const UPDATE_A_USER = 'user/UPDATE_A_USER';
export const CLEAR_A_USER_ERROR_MESSAGE = 'user/CLEAR_A_USER_ERROR_MESSAGE';


export function clearUserErrorMsgInStore() {
	return {
		type: CLEAR_A_USER_ERROR_MESSAGE,
		
	}
}

export function loadUserDataInStore(argUserDataArray) {
	return {
		type: LOAD_USER_DATA,
		usersData: argUserDataArray
	}
}


export function loadSingleUserDataInStore(argUserData) {
	return {
		type: SAVE_A_USER,
		saveUserResponse: argUserData
	}
}

export function deleteAUserDataInStore(argDeleteResponse, argErrorMsg) {
	return {
		type: DELETE_A_USER,
		deleteUserResponse: argDeleteResponse,
		errorMsg: argErrorMsg
	}
}

export function saveAUserDataInStore(argSaveResponse, argErrorMsg) {
	return {
		type: SAVE_A_USER,
		saveUserResponse: argSaveResponse,
		errorMsg: argErrorMsg
	}
}

export function updateAUserDataInStore(argSaveResponse, argErrorMsg) {
	return {
		type: UPDATE_A_USER,
		updateUserResponse: argSaveResponse,
		errorMsg: argErrorMsg
	}
}

/********************* End of InStore calls **************************/




//****************************************
//Below is for update a Stream
//****************************************

export function clearUserErrorMsg() {
	return (dispatch, getState) => {
		dispatch(clearUserErrorMsgInStore());
	}
}


export function updateAUser(argURL, argCamera) {
	return (dispatch, getState) => {
		const state = getState();
		updateAUserOnServer(argURL, argCamera, state.login.loginData.idToken).then(function (saveResponse) {
			
			dispatch(saveAUserDataInStore(saveResponse.data, {
				"status": saveResponse.status,
				"statusText": saveResponse.statusText
			}));
			
		}, function (err) {
			var errorObj = AppUtils.getErroStatusAndText(err);
			console.log("I had an error updating a user" + errorObj.statusText + errorObj.status);
			dispatch(saveAUserDataInStore({}, errorObj));
		});
	}//end of return
}


function updateAUserOnServer(argURL, argCamera, argIdToken) {
	
	var returnPromise = new Promise(function (resolve, reject) {
		
		if ((argURL != null) || (argURL.length != 0)) {
			axios.all(getArrayOfPutsForUpdateAUser(argURL, argCamera, argIdToken)).then(function (responses) {
				resolve(responses[0]);
			}, function (err) {
				//console.log("Farshid some error occured on saving a users " + err.message +  " the URL is " + argURL );
				reject(err);
			});
		}
	});
	
	return returnPromise;
}


function getArrayOfPutsForUpdateAUser(argURL, argCamera, argIdToken) {
	/*
	 I build something like this :
	 http://localhost:4567/users
	 */
	
	let baseUrl = argURL + "users";
	//console.log(" on posting a useries the URL is " + baseUrl );
	
	var arrayOfGets = [];
	if (argURL != null) {
		arrayOfGets.push(axios.put(baseUrl, argCamera, {headers: {"Authorization": `Bearer ${argIdToken}`}}));
	}
	return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveAUser(argURL, argCamera) {
	return (dispatch, getState) => {
		const state = getState();
		saveAUserOnServer(argURL, argCamera, state.login.loginData.idToken).then(function (saveResponse) {
			
			dispatch(saveAUserDataInStore(saveResponse.data, {
				"status": saveResponse.status,
				"statusText": saveResponse.statusText
			}));
			
		}, function (err) {
			var errorObj = AppUtils.getErroStatusAndText(err);
			console.log("I had an error saving a user" + errorObj.statusText + errorObj.status);
			dispatch(saveAUserDataInStore({}, errorObj));
		});
	}//end of return
}


function saveAUserOnServer(argURL, argCamera, argIdToken) {
	
	var returnPromise = new Promise(function (resolve, reject) {
		
		if ((argURL != null) || (argURL.length != 0)) {
			axios.all(getArrayOfPostsForSaveAUser(argURL, argCamera, argIdToken)).then(function (responses) {
				resolve(responses[0]);
			}, function (err) {
				//console.log("Farshid some error occured on saving a users " + err.message +  " the URL is " + argURL );
				reject(err);
			});
		}
	});
	
	return returnPromise;
}


function getArrayOfPostsForSaveAUser(argURL, argCamera, argIdToken) {
	/*
	 I build something like this :
	 http://localhost:4567/users
	 */
	
	let baseUrl = argURL + "users";
	//console.log(" on posting a useries the URL is " + baseUrl );
	
	var arrayOfGets = [];
	if (argURL != null) {
		arrayOfGets.push(axios.post(baseUrl, argCamera, {headers: {"Authorization": `Bearer ${argIdToken}`}}));
	}
	return arrayOfGets;
}


//****************************************
//Below is for delete a user
//****************************************
export function deleteAUser(argURL, argCameraId) {
	return (dispatch, getState) => {
		const state = getState();
		
		deleteAUserOnServer(argURL, argCameraId, state.login.loginData.idToken).then(function (deleteResponse) {
			
			dispatch(deleteAUserDataInStore(deleteResponse.data, {
				"status": deleteResponse.status,
				"statusText": deleteResponse.statusText
			}));
			
		}, function (err) {
			var errorObj = AppUtils.getErroStatusAndText(err);
			//console.log("I had an error gettting Stream Data2" + err);
			dispatch(deleteAUserDataInStore({}, errorObj));
		});
	}//end of return
}


function deleteAUserOnServer(argURL, argStreamId, argIdToken) {
	
	var returnPromise = new Promise(function (resolve, reject) {
		if ((argURL != null) || (argURL.length != 0)) {
			axios.all(getArrayOfDeletesForDeleteAUser(argURL, argStreamId, argIdToken)).then(function (responses) {
				resolve(responses[0]);
			}, function (err) {
				//console.log("Farshid some error occured on deleteing a user " + err.message +  " the URL is " + argURL );
				reject(err);
			});
		}
	});
	
	return returnPromise;
}


function getArrayOfDeletesForDeleteAUser(argURL, argStreamId, argIdToken) {
	/*
	 I build something like this :
	 http://localhost:4567/cameras
	 */
	
	let baseUrl = argURL + "users" + "/" + argStreamId;
	console.log(" on deleteing a user the URL is " + baseUrl);
	
	var arrayOfGets = [];
	if (argURL != null) {
		arrayOfGets.push(axios.delete(baseUrl, {headers: {"Authorization": `Bearer ${argIdToken}`}}));
	}
	return arrayOfGets;
}


//Get list of users

export function loadUsersData(argURL) {
	console.log("loadUsersData is called -url is " + argURL);
	return (dispatch, getState) => {
		const state = getState();
		//let tempToken = state.login.loginData.idToken
		getListOfUsers(argURL, state.login.loginData.idToken).then(function (usersList) {
			console.log("loadUsersData the returned data is ");
			console.log(usersList);
			dispatch(loadUserDataInStore(usersList));
			
		}, function (err) {
			console.log("I had an error getting load user data" + err);
		});
	}//end of return
}

function getArrayOfGetsForListOfUsers(argURL, argTokenId) {
	/*
	 I build something like this :
	 http://localhost:4567/user
	 */
	
	let baseUrl = argURL + "userbysubject";
	//console.log(" on getting list of Users  the URL is " + baseUrl);
	//console.log(" getArrayOfGetsForSingleUser:  TokenId is " + argTokenId);
	
	
	var arrayOfGets = [];
	if (argURL != null) {
		arrayOfGets.push(axios.get(baseUrl, {headers: {"Authorization": `Bearer ${argTokenId}`}}));
	}
	return arrayOfGets;
}

function getListOfUsers(argURL, argTokenId) {
	
	var returnPromise = new Promise(function (resolve, reject) {
		
		var arrayOfGets = [];
		
		if ((argURL != null) || (argURL.length != 0)) {
			axios.all(getArrayOfGetsForListOfUsers(argURL, argTokenId)).then(function (responses) {
				resolve(responses[0].data);
			}, function (err) {
				console.log("Farshid some error occured on getting list of Users " + err.message + " the URL is " + argURL);
				reject(err);
			});
		}
	});
	
	return returnPromise;
}


function getUserDataFromRemoteServer(argURL, argUsersList) {
	
	var returnPromise = new Promise(function (resolve, reject) {
		
		var arrayOfGets = [];
		
		if (argUsersList != null) {
			
			axios.all(getArrayOfGets(argURL, argUsersList)).then(function (responses) {
				resolve(responses);
				
			}, function (err) {
				console.log("Farshid some error occured " + err.message);
				reject(err);
			});
		}
	});
	
	return returnPromise;
}

function getArrayOfGets(argURL, argFarmsList) {
	
	
	let baseUrl = argURL;
	
	
	var arrayOfGets = [];
	if (argFarmsList != null) {
		for (var i = 0; i < argFarmsList.length; i++) {
			let responseData = argFarmsList[i];
			//let responseData = singleResponse.data;
			//if((argMetricList[i].checked != null) && (argMetricList[i].checked == true) ) {
			let tempURl = baseUrl + "GRAPHS" + "/farm_summary?farmId=" + responseData.id;
			console.log("Farshid the User DATA URL is =" + tempURl);
			arrayOfGets.push(axios.get(tempURl));
			
			//}
		}
	}
	return arrayOfGets;
	
	
}


//Get A Single User

export function loadSingleUserData(argURL) {
	console.log("loadSingleUserData is called!");
	return (dispatch, getState) => {
		const state = getState();
		//let tempToken = state.login.loginData.idToken
		getSingleUser(argURL, state.login.loginData.idToken).then(function (userData) {
			
			dispatch(loadSingleUserDataInStore(userData));
			
		}, function (err) {
			console.log("I had an error getting Farms Data2" + err);
		});
	}//end of return
}

export function getSingleUser(argURL, argTokenId) {
	
	var returnPromise = new Promise(function (resolve, reject) {
		
		var arrayOfGets = [];
		
		if ((argURL != null) || (argURL.length != 0)) {
			axios.all(getArrayOfGetsForSingleUser(argURL, argTokenId)).then(function (responses) {
				resolve(responses[0].data);
			}, function (err) {
				console.log("Farshid some error occured on getting list of Users " + err.message + " the URL is " + argURL);
				reject(err);
			});
		}
	});
	
	return returnPromise;
}

function getArrayOfGetsForSingleUser(argURL, argTokenId) {
	
	let baseUrl = argURL + "userbysubject";
	//console.log(" on getting list of Users  the URL is " + baseUrl);
	//console.log(" getArrayOfGetsForSingleUser : argToken is  " + argTokenId);
	
	var arrayOfGets = [];
	if (argURL != null) {
		arrayOfGets.push(axios.get(baseUrl, {headers: {"Authorization": `Bearer ${argTokenId}`}}));
	}
	return arrayOfGets;
}


//Get A Single User and His or Her list Of Comapnies

export function loadSingleUserAndCompanyData(argURL) {
	return (dispatch, getState) => {
		const state = getState();
		//let tempToken = state.login.loginData.idToken
		getSingleUser(argURL, state.login.loginData.idToken).then(function (userData) {
			
			dispatch(loadSingleUserDataInStore(userData));
			dispatch(loadCompanysDataWithUserId(argURL, userData.id));
			
		}, function (err) {
			console.log("I had an error gettting Farms Data2" + err);
		});
	}//end of return
}


/*
export function loadUserData(argURL) {
    return (dispatch, getState) => {


        var arrayOfUserData=[];
        getListOfUsers(argURL).then(function(usersList){

            for(var z=0; z<usersList.length; z++){

                let singleResponse = usersList[z];
                let responseData = singleResponse.data;
                getUserDataFromRemoteServer(argURL,responseData ).then(function (farmsData){
                    for(var i=0; i<farmsData.length; i++) {
                        arrayOfUserData.push(farmsData[i].data);
                    }
                    dispatch(loadUserDataInStore(arrayOfUserData));

                }, function (err){
                    console.log("I had an error gettting Farms Data3333" + err);
                });

            }
    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}
 */
